module.exports = __webpack_public_path__ + "static/media/mixa.aff36048.mp3";